import React from 'react';
import { withStyles, Grid, Typography, ButtonBase } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import Match from '../../model/Match';
import DateUtils from '../../control/dateutils';
 
const PLAYICON = require("../../images/icons/living.gif");

class LiveContent extends React.Component {

    render() {
        const { classes, data } = this.props;
        let match = new Match(data);
        let text = '正在直播';
        if (!match.living()) {
            text = DateUtils.dateFormatHM(match.match_time * 1000);
        }
        let homeScore = match.getHomeScore();
        let away_scores = match.getAwayScore();
        return (
            <ButtonBase onClick={() => this.props.history.push({ pathname: '/play/' + 0 + '/' + match.type_id + '/' + match.id, data: match })} >
                <Grid container direction='column' alignItems='center' justify='space-between' className={classes.root}>
                    <Grid container alignItems='center' direction='row' justify='space-between' className={classes.titleContainer}>
                        <Typography className={classes.title} >{data.short_name_zh}</Typography>
                        <Grid container alignItems='center' direction='row' justify='flex-end' style={{ flex: 1 }}>
                            <Typography className={classes.liveText} style={{ color: match.living() ? '#FB0000' : '#0D0D0D' }} >{text}</Typography>
                            {
                                match.living() && <img src={PLAYICON} className={classes.playIcon} />
                            }
                        </Grid>
                    </Grid>
                    <Grid container alignItems='center' direction='row' justify='space-between' className={classes.content} >
                        <Grid container alignItems='center' direction='row'  >
                            <img src={data.home_log} className={classes.icon} />
                            <Typography noWrap={true} className={classes.contentText} >{data.home_name}</Typography>
                            <Typography className={classes.scoreText} style={{ position: 'absolute', right: 8 }} >{homeScore}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container alignItems='center' direction='row' justify='space-between' className={classes.bottom}>
                        <Grid container alignItems='center' direction='row'  >
                            <img src={data.away_log} className={classes.icon} />
                            <Typography noWrap={true} className={classes.contentText} >{data.away_name}</Typography>
                            <Typography className={classes.scoreText} style={{ position: 'absolute', right: 8, color: '#C2C2C2' }} >{away_scores}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </ButtonBase>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: 185,
        height: 86,
        border: '1px solid #F5F5F5',
        backgroundColor: '#FFF',
        borderRadius: 8,
    },
    title: {
        color: '#898989',
        fontSize: 9,
        margin: theme.spacing(0, 0, 0, 1),
    },
    liveText: {
        color: '#FB0000',
        fontSize: 9,
        margin: theme.spacing(0, 1, 0, 1),
    },
    scoreText: {
        color: '#0D0D0D',
        fontSize: 12,
        margin: theme.spacing(0, 1, 0, 1),
    },
    titleContainer: {
        height: 24,
        width: '100%',
        flex: 1,
    },
    content: {
        backgroundColor: '#FFF',
        width: '100%',
        height: 37,
        padding: theme.spacing(0, 0, 0, 1),
    },
    contentText: {
        color: '#0D0D0D',
        fontSize: 11,
        margin: theme.spacing(0, 1, 0, 1),
        maxWidth: 135,
    },
    icon: {
        maxWidth: 14,
        maxHeight: 14,
    },
    playIcon: {
        width: 10,
        height: 10,
        margin: theme.spacing(0, 1.5, 0, 0),
    },
    bottom: {
        height: 23,
        width: '100%',
        backgroundColor: '#FFF',
        marginBottom: 1,
        padding: theme.spacing(0, 0, 0, 1),
    }

}))(LiveContent));